var React = require('react');

function Padlock (props) {
    return React.createElement("svg",props,React.createElement("path",{"clipRule":"evenodd","d":"m7 6c0-2.76142 2.23858-5 5-5 2.7614 0 5 2.23858 5 5v5c1.1046 0 2 .8954 2 2v8c0 1.1046-.8954 2-2 2h-10c-1.10457 0-2-.8954-2-2v-8c0-1.1046.89543-2 2-2zm1.5 5v-5c0-1.933 1.567-3.5 3.5-3.5s3.5 1.567 3.5 3.5v5zm-2.3 2.2c0-.5523.44772-1 1-1h9.6c.5523 0 1 .4477 1 1v7.6c0 .5523-.4477 1-1 1h-9.6c-.55229 0-1-.4477-1-1zm5.8 3.8c-.5523 0-1 .4477-1 1v1c0 .5523.4477 1 1 1s1-.4477 1-1v-1c0-.5523-.4477-1-1-1z","fillRule":"evenodd"}));
}

Padlock.defaultProps = {"fill":"currentColor","viewBox":"0 0 24 24"};

module.exports = Padlock;

Padlock.default = Padlock;
